// extracted by mini-css-extract-plugin
module.exports = {"icon":"WeatherIcon_icon__UqyAo"};